<chart-details-layout
  [chartDetails]="chartDetails"
  [isLoading]="isLoading"
  [showFormButtons]="showFormButtons"
  (save)="onSaveSettings()"
  (cancel)="onRevertSettings()"
>
  <manuals-printed-chart
    chart
    [showTitle]="false"
    [startDate]="null"
    [endDate]="null"
  ></manuals-printed-chart>
  <base-details
    detailsComponent
    *ngIf="!isLoading"
    [chartDetails]="chartDetails"
    [generalSettings]="config?.generalSettings"
    (generalSettingsChange)="onGeneralSettingsChange($event)"
  >
    <div #filterContent>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback" style="position: relative;">
            <label
              class="control-group input-group-addon"
              for="selectTimePeriod"
              >Time Period
                <button class="info-btn"
                        type="button"
                        [attr.title]="info('timePeriod')"
                        (click)="onInfoClick($event, 'timePeriod')">
                    i
                </button>
              </label
            >
            <select
              id="selectTimePeriod"
              name="selectTimePeriod"
              [(ngModel)]="selectedTimePeriod"
              class="form-control"
              (click)="hideTooltip()"
            >
              <option value="" [selected]="selectedTimePeriod === ''">
                -- Select Time Period --
              </option>
              <option *ngFor="let period of timePeriods" [value]="period.value">
                {{ period.display }}
              </option>
            </select>

            <div class="click-tooltip"
                 *ngIf="isTooltipVisible('timePeriod')"
                 (click)="hideTooltip()">
              {{ info('timePeriod') }}
            </div>
          </div>
        </div>
      </div>
      <!-- Deprecated: field to select columns in sub tables -->
      <!-- <div class="row">
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback">
            <label
              class="control-group input-group-addon"
              style="
                vertical-align: top;
                white-space: break-spaces;
                text-align: left;
                line-height: 1.5em;
              "
              title="Choose printed details to display"
              >Printed Details</label
            >
            <div class="form-control" style="height: unset">
              <ng-container
                *ngIf="
                  config?.generalSettings?.legendLabels.includes('User Data');
                  else noOptions
                "
              >
                <div
                  *ngFor="let option of chartDetails.customLabels['User Data']"
                  class="form-check"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [id]="option"
                    [value]="option"
                    [checked]="config?.customLabelSelection?.includes(option)"
                    (change)="toggleCustomLabelOption(option)"
                  />
                  <label [for]="option" class="form-check-label">
                    {{ option }}
                  </label>
                </div>
              </ng-container>
              <ng-template #noOptions>
                <p>
                  Choose the option 'User Data' below to see individual details
                  available.
                </p>
              </ng-template>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </base-details>
</chart-details-layout>
